import { z } from 'zod'

// Create a recursive schema for nested messages
const createNestedMessageSchema = (): z.ZodType<Record<string, string | Record<string, any>>> => {
    return z.lazy(() =>
        z.record(
            z.string(),
            z.union([z.string(), z.record(z.string(), z.union([z.string(), nestedMessageSchema]))]),
        ),
    )
}

const nestedMessageSchema = createNestedMessageSchema()

/**
 * Translation form validation schema
 * Matches the server-side TranslationFormSchema
 */
export const translationFormSchema = z.object({
    locale: z.string().min(1, 'Locale is required'),
    countryCode: z.string().min(1, 'Country code is required'),
    messages: nestedMessageSchema,
    enabled: z.boolean(),
})

export type TranslationFormData = z.infer<typeof translationFormSchema>

